/** The treasure chest kids actually want to tap. Icon only — the label lives in
 *  the tooltip. Bounces while there are unopened coins inside. */
const CHEST_SRC = 'https://static.prod-images.emergentagent.com/jobs/eb175c5d-51a0-4ace-b433-822f579519a6/images/f894c6f567b856285bbb9287e4bb5ee0d383f342edddb76a718fbf2e5b82c08c.jpeg';

export function TreasureChest({ className = 'w-7 h-7', shake = false, coins = 0 }) {
  return (
    <span className="relative inline-flex" title="My Veda Coins" aria-label="My Veda Coins">
      <img src={CHEST_SRC} alt="My Veda Coins" loading="lazy"
        className={`${className} rounded-full object-cover shadow-sm ring-1 ring-amber-300/70 ${shake ? 'gv-chest-shake' : ''}`} />
      {coins > 0 && (
        <span data-testid="nav-chest-count"
          className="absolute -top-1.5 -right-1.5 min-w-[18px] px-1 h-[18px] rounded-full bg-rose-500 text-white text-[9px] font-heading flex items-center justify-center shadow">
          {coins > 9999 ? `${Math.floor(coins / 1000)}k` : coins}
        </span>
      )}
    </span>
  );
}

export default TreasureChest;
